const url = '/regions';
const Provider = 'Regions';
const dbModel = 'Regions';

export { url, Provider, dbModel };
